import type { Config } from "@puckeditor/core";
import { BlogPageSurface } from "@/components/blog/BlogPageBackground";
import { blogBlocks } from "@/puck/blocks/blogBlocks";
import { createImportStructureConfig } from "@/puck/blocks/shared/importStructureConfig";
import { applyAnchorsToComponents } from "@/puck/fields/anchorField";
import type { BlogPageComponents, BlogRootProps } from "@/puck/types";

const blogPuckConfig: Config<BlogPageComponents, BlogRootProps> = {
  root: {
    fields: {
      title: { type: "text", label: "Article title (SEO)" },
      description: { type: "textarea", label: "Meta description" },
      keywords: {
        type: "textarea",
        label: "Keywords (comma-separated)",
      },
    },
    render: ({ children, puck }) => {
      const article = (
        <article className="prose prose-neutral min-w-0 max-w-none prose-strong:text-inherit [&_.gail-blue-text]:!text-gail-primary [&_.gail-blue-text_*]:!text-gail-primary">
          {children}
        </article>
      );

      if (puck.isEditing) {
        return (
          <BlogPageSurface className="relative min-h-full bg-blog-page-fixed">
            {article}
          </BlogPageSurface>
        );
      }

      return article;
    },
  },
  categories: {
    blog: {
      title: "Blog",
      components: [
        "BlogHeading",
        "BlogRichText",
        "BlogImage",
        "BlogCallout",
        "BlogCTA",
        "BlogCTAGroup",
        "BlogTwoColumn",
        "BlogSourceRef",
        "BlogROICalculator",
        "BlogGrouping",
        "BlogLineText",
        "BlogAlign",
        "BlogVideo",
        "BlogCalendar",
        "BlogSnippet",
        "ImportStructure",
      ],
      defaultExpanded: true,
    },
  },
  components: applyAnchorsToComponents({
    ...blogBlocks,
    ImportStructure: createImportStructureConfig("blog"),
  }),
};

export default blogPuckConfig;
